// 基础路由
var baseRouter = [{
  path: '/home',
  component: function component(resolve) {
    return require(['@/views/dashboard'], resolve);
  },
  name: 'home',
  meta: {
    title: 'home',
    icon: 'icon-ym icon-ym-nav-home',
    affix: true,
    zhTitle: '首页'
  }
},
// {
//   path: '/dashboard',
//   component: (resolve) => require(['@/views/basic/dashboard'], resolve),
//   name: 'dashboard',
//   meta: {
//     title: 'dashboard',
//     icon: 'icon-ym icon-ym-generator-kanban',
//     affix: true,
//     zhTitle: '门户展示'
//   }
// },
{
  path: '/messageRecord',
  component: function component(resolve) {
    return require(['@/views/basic/messageRecord'], resolve);
  },
  name: 'messageRecord',
  meta: {
    title: 'messageRecord',
    affix: false,
    zhTitle: '消息中心',
    icon: 'icon-ym icon-ym-sysNotice'
  }
}, {
  path: '/previewModel',
  component: function component(resolve) {
    return require(['@/views/basic/dynamicModel'], resolve);
  },
  name: 'previewModel',
  meta: {
    title: 'previewModel',
    affix: false,
    zhTitle: '功能预览',
    icon: 'icon-ym icon-ym-btn-preview'
  }
}, {
  path: '/profile',
  component: function component(resolve) {
    return require(['@/views/basic/profile'], resolve);
  },
  name: 'profile',
  meta: {
    title: 'profile',
    affix: false,
    zhTitle: '个人信息',
    icon: 'icon-ym icon-ym-user'
  }
}];
export default baseRouter;